<div class="wsb-shell">
  <div class="wsb-header">
    <div class="wsb-header-text">
      <h2 class="wsb-title">Programación masiva de horarios</h2>
      <div class="wsb-subtitle">{{ subtitle }}</div>
    </div>

    <div class="wsb-filters">
      <div class="wsb-filter-group">
        <label class="wsb-filter-label">Nombre del proyecto</label>

        <mat-form-field class="wsb-filter-field" appearance="fill">
          <mat-select
            panelClass="wsb-combo-select-panel"
            [disableOptionCentering]="true"
            [value]="data.projectId"
            [disabled]="scheduleLoading || availableProjects.length === 0 || !canSave"
            [matTooltip]="!canSave ? 'No cuentas con el permiso para programar la jornada' : data.projectName"
            (selectionChange)="selectProject($event.value)"
          >
            <mat-option
              *ngFor="let project of availableProjects"
              [value]="project.id"
              [disabled]="!project.isActive"
            >
              {{ project.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div
        class="wsb-filter-group"
        *ngIf="companies.length > 0"
      >
        <label class="wsb-filter-label">Empresas</label>

        <mat-form-field class="wsb-filter-field" appearance="fill">
          <mat-select
            panelClass="wsb-combo-select-panel"
            [disableOptionCentering]="true"
            [(ngModel)]="companyFilterValue"
            [disabled]="scheduleLoading || !canSave"
            [matTooltip]="!canSave ? 'No cuentas con el permiso para programar la jornada' : ''"
          >
            <mat-option [value]="ALL_COMPANIES">
              Todas las empresas
            </mat-option>

            <mat-option
              *ngFor="let company of companies"
              [value]="company.employerId"
            >
              {{ company.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="wsb-week-nav">
      <button
        class="wsb-week-btn"
        type="button"
        [disabled]="scheduleLoading"
        (click)="goPrevWeek()"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>

      <div class="wsb-week-label">
        Semana {{ weekRangeLabel }}
      </div>

      <button
        class="wsb-week-btn"
        type="button"
        [disabled]="scheduleLoading"
        (click)="goNextWeek()"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <div class="wsb-header-actions">
      <span
        [matTooltip]="!canSave ? 'No cuentas con el permiso para programar la jornada' : ''"
        matTooltipPosition="above"
        style="display: inline-block"
      >
        <button
          class="wsb-btn-clear"
          type="button"
          [disabled]="!canSave || saving"
          (click)="clearWeek()"
        >
          LIMPIAR
        </button>
      </span>

      <button
        class="wsb-btn-cancel"
        type="button"
        [disabled]="saving"
        (click)="close()"
      >
        CANCELAR
      </button>
    </div>
  </div>

  <div class="wsb-render-error" *ngIf="renderError">
    <strong>Ocurrió un error mostrando esta vista:</strong>
    <div>{{ renderError }}</div>

    <div class="wsb-render-error-hint">
      Copia este mensaje y compártelo para poder corregirlo.
    </div>
  </div>

  <div class="wsb-save-result" *ngIf="saveResult">
    <div class="wsb-save-result-header">
      <span>
        <strong>{{ saveResult.Applied }}</strong> completos ·
        <strong>{{ saveResult.Partial }}</strong> parciales ·
        <strong>{{ saveResult.Skipped }}</strong> sin cambios

        <ng-container *ngIf="saveResult.WithWarnings > 0">
          · <strong>{{ saveResult.WithWarnings }}</strong> con avisos
        </ng-container>

        de {{ saveResult.Requested }} solicitados
      </span>

      <button
        type="button"
        class="wsb-save-result-close"
        (click)="dismissSaveResult()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div
      class="wsb-save-result-item"
      *ngFor="let item of saveResult.Items"
    >
      <span
        class="wsb-save-result-status"
        [ngClass]="'wsb-save-result-status--' + item.Status"
      >
        {{ describeStatus(item.Status) }}
      </span>

      <span class="wsb-save-result-name">
        {{ item.PersonalName }}
      </span>

      <span class="wsb-save-result-message">
        {{ describeItemMessage(item) }}
      </span>
    </div>
  </div>

  <div class="wsb-body" *ngIf="!loading; else loadingTpl">
    <div class="wsb-strips" *ngIf="weeklyPatterns.length > 0 || dailyShifts.length > 0 || rotationCards.length > 0">
      <div
        class="wsb-strip-block"
        *ngIf="dailyShifts.length > 0"
      >
        <div class="wsb-strip-label wsb-strip-label--turnos">
          TURNOS
        </div>

        <div class="wsb-strip-grid">
          <div
            class="wsb-chip"
            *ngFor="let pattern of dailyShifts"
            [style.background]="pattern.color"
            [class.wsb-chip--armed]="tapArmedPatternId === pattern.id"
            [class.wsb-chip--disabled]="!canSave"
            [attr.draggable]="canSave"
            (dragstart)="onPatternDragStart($event, pattern.id)"
            (dragend)="onDragEnd()"
            (click)="armPatternForTap(pattern.id)"
          >
            <div class="wsb-chip-name">
              {{ pattern.name }}
            </div>

            <div class="wsb-chip-hours">
              {{ getShiftTimeRangeLabel(pattern) }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="wsb-strip-row"
        *ngIf="weeklyPatterns.length > 0"
      >
        <div class="wsb-strip-label">
          PATRONES
        </div>

        <div class="wsb-strip-scroll">
          <div
            class="wsb-pattern-card"
            *ngFor="let pattern of weeklyPatterns"
            [class.wsb-chip--armed]="tapArmedPatternId === pattern.id"
            [class.wsb-chip--disabled]="!canSave"
            [attr.draggable]="canSave"
            (dragstart)="onPatternDragStart($event, pattern.id)"
            (dragend)="onDragEnd()"
            (click)="armPatternForTap(pattern.id)"
          >
            <div class="wsb-pattern-card-header">
              <span
                class="wsb-pattern-card-dot"
                [style.background]="pattern.color"
              ></span>

              <div class="wsb-pattern-card-name">
                {{ pattern.name }}
              </div>

              <div class="wsb-pattern-card-hours">
                {{ pattern.totalWeekHours | number:'1.0-1' }} h
              </div>
            </div>

            <div class="wsb-pattern-card-days">
              <span
                class="wsb-pattern-day-chip"
                *ngFor="let day of pattern.days"
                [style.background]="day.color || pattern.color"
                [matTooltip]="letterLabels[day.letter]"
              >
                {{ day.letter }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="wsb-strip-row"
        *ngIf="rotationCards.length > 0"
      >
        <div class="wsb-strip-label">
          PATRONES CATORCENALES
        </div>

        <div class="wsb-strip-scroll">
          <!-- Informativos: las rotaciones se asignan desde la programación de horarios de cada persona. -->
          <div
            class="wsb-pattern-card wsb-pattern-card--info"
            *ngFor="let rotation of rotationCards"
            matTooltip="Se asigna desde la programación de horarios de cada persona"
            matTooltipPosition="above"
          >
            <div class="wsb-pattern-card-header">
              <span class="wsb-pattern-card-dot wsb-pattern-card-dot--rotation"></span>

              <div class="wsb-pattern-card-name">
                {{ rotation.name }}
              </div>

              <div class="wsb-pattern-card-hours">
                {{ rotation.totalHours | number:'1.0-1' }} h
              </div>
            </div>

            <!-- Una semana por fila (7 botones delgados): el ciclo de 14 días se ve en dos filas. -->
            <div class="wsb-pattern-card-days wsb-pattern-card-days--rotation">
              <span
                class="wsb-pattern-day-chip"
                *ngFor="let day of rotation.days"
                [style.background]="day.color"
                [matTooltip]="letterLabels[day.letter]"
              >
                {{ day.letter }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="wsb-strip-hint">
        Suelta sobre <strong>una persona</strong> o sobre la
        <strong>cabecera "Persona"</strong> (varias seleccionadas) para
        repetir el patrón completo por semanas. Sobre <strong>una celda</strong>
        (solo ese día) o la <strong>cabecera de un día</strong> (esa jornada a
        las seleccionadas) se aplica al instante, sin repetir.
      </div>

      <!-- Dentro de .wsb-strips (no como hermano) para que la rueda del mouse siga pudiendo
           hacer scroll del sidebar — un overlay hermano rompe la cadena de scroll. -->
      <div
        class="wsb-frozen-overlay"
        *ngIf="!canSave"
        matTooltip="No cuentas con el permiso para programar la jornada"
        matTooltipPosition="above"
      ></div>
    </div>

    <div
      class="wsb-empty-hint wsb-empty-hint--patterns"
      *ngIf="weeklyPatterns.length === 0 && dailyShifts.length === 0 && rotationCards.length === 0"
    >
      Este proyecto no tiene turnos activos. Crea uno en
      "HORARIOS DE TRABAJO".
    </div>

    <section class="wsb-main">
      <div class="wsb-toolbar">
        <div class="wsb-search">
          <mat-icon>search</mat-icon>

          <input
            type="text"
            placeholder="Buscar persona o cargo..."
            [(ngModel)]="searchText"
          />
        </div>

        <div class="wsb-pagination-block">
          <div class="wsb-selection-banner">
            <span class="wsb-selection-count">
              {{ selectedPersonIds.size }} seleccionadas
            </span>

            <span
              class="wsb-selection-ok"
              *ngIf="
                maxWeeklyHours > 0 &&
                overLimitCount === 0 &&
                filteredPersonnel.length > 0
              "
            >
              <mat-icon>check_circle</mat-icon>
              Todas dentro de la jornada máxima
              ({{ maxWeeklyHours }} h)
            </span>

            <span
              class="wsb-selection-warning"
              *ngIf="overLimitCount > 0"
            >
              <mat-icon>warning</mat-icon>

              {{ overLimitCount }}
              {{
                overLimitCount === 1
                  ? 'persona supera'
                  : 'personas superan'
              }}
              la jornada máxima
            </span>
          </div>

          <div
            class="wsb-pagination-controls"
            *ngIf="totalPeople > 0"
          >
            <button
              type="button"
              class="wsb-page-arrow"
              [disabled]="scheduleLoading || page <= 1"
              (click)="goPrevPage()"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>

            <ng-container *ngFor="let p of visiblePages">
              <span
                *ngIf="p === '...'"
                class="wsb-page-ellipsis"
              >
                ...
              </span>

              <button
                *ngIf="p !== '...'"
                type="button"
                class="wsb-page-number"
                [class.wsb-page-number--active]="isCurrentPage(p)"
                [disabled]="scheduleLoading"
                (click)="goToPage(p)"
              >
                {{ p }}
              </button>
            </ng-container>

            <button
              type="button"
              class="wsb-page-arrow"
              [disabled]="scheduleLoading || page >= totalPages"
              (click)="goNextPage()"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="wsb-table-wrapper">
        <table class="wsb-table">
          <thead>
          <tr>
            <th
              class="wsb-col-person"
              [class.wsb-col-person--dragover]="
                  isDragOver('col:persons')
                "
              (dragover)="
                  selectedPersonIds.size > 0 &&
                  onDragOverTarget($event, 'col:persons')
                "
              (dragleave)="onDragLeaveTarget()"
              (drop)="onDropPersonsHeader($event)"
            >
              <div class="wsb-select-all">
                <span
                  [matTooltip]="!canSave ? 'No cuentas con el permiso para programar la jornada' : ''"
                  matTooltipPosition="above"
                  style="display: inline-block"
                >
                  <mat-checkbox
                    [checked]="allFilteredSelected"
                    [disabled]="filteredPersonnel.length === 0 || !canSave"
                    (change)="toggleSelectAll()"
                  ></mat-checkbox>
                </span>

                <span>Persona</span>
              </div>
            </th>

            <th
              class="wsb-col-day"
              *ngFor="let day of weekDays"
              [class.wsb-col-day--weekend]="
                  day.isWeekend && !day.isHoliday
                "
              [class.wsb-col-day--holiday]="day.isHoliday"
              [class.wsb-col-day--dragover]="
                  isDragOver('col:' + day.dayNumber)
                "
              [matTooltip]="day.isHoliday ? 'Festivo' : ''"
              matTooltipPosition="above"
              (dragover)="
                  onDragOverTarget(
                    $event,
                    'col:' + day.dayNumber
                  )
                "
              (dragleave)="onDragLeaveTarget()"
              (drop)="onDropColumn($event, day)"
              (click)="onTapColumn(day)"
            >
              <div class="wsb-day-label">
                {{ day.shortLabel }}
              </div>

              <div class="wsb-day-number-row">
                  <span class="wsb-day-number">
                    {{ day.dayOfMonth }}
                  </span>

                <span
                  class="wsb-day-holiday-badge"
                  *ngIf="day.isHoliday"
                >
                    FESTIVO
                  </span>
              </div>
            </th>

            <th class="wsb-col-total">
              Semana
            </th>
          </tr>
          </thead>

          <tbody>
          <tr
            class="wsb-row"
            *ngFor="let row of filteredPersonnel"
            [class.wsb-row--dragover]="
                isDragOver('row:' + row.id)
              "
            [class.wsb-row--selected]="
                isPersonSelected(row.id)
              "
            [class.wsb-row--unscheduled]="
                row.unscheduledDays > 0
              "
            (dragover)="
                onDragOverTarget($event, 'row:' + row.id)
              "
            (dragleave)="onDragLeaveTarget()"
            (drop)="onDropRow($event, row)"
          >
            <td
              class="wsb-col-person"
              (click)="onTapRow(row)"
            >
              <div class="wsb-person-cell">
                <span
                  [matTooltip]="!canSave ? 'No cuentas con el permiso para programar la jornada' : ''"
                  matTooltipPosition="above"
                  style="display: inline-block"
                >
                  <mat-checkbox
                    [checked]="isPersonSelected(row.id)"
                    [disabled]="!canSave"
                    (click)="$event.stopPropagation()"
                    (change)="togglePerson(row.id)"
                  ></mat-checkbox>
                </span>

                <div class="wsb-person-avatar">
                  {{ row.initials }}
                </div>

                <div class="wsb-person-info">
                  <div class="wsb-person-name">
                    {{ row.fullName }}
                  </div>

                  <div class="wsb-person-meta">
                    {{ row.documentNumber }}
                  </div>

                  <div
                    class="wsb-person-warning"
                    *ngIf="row.unscheduledDays > 0"
                    [matTooltip]="
                        row.unscheduledDays +
                        ' día(s) sin turno vigente en el rango cargado'
                      "
                  >
                    <mat-icon>warning</mat-icon>
                    {{ row.unscheduledDays }} sin turno
                  </div>
                </div>
              </div>
            </td>

            <td
              class="wsb-col-day wsb-cell"
              *ngFor="let day of weekDays"
              [class.wsb-cell--offday]="
                  day.isWeekend || day.isHoliday
                "
              [class.wsb-cell--weekend]="
                  day.isWeekend && !day.isHoliday
                "
              [class.wsb-cell--holiday]="day.isHoliday"
              [class.wsb-cell--dragover]="
                  isDragOver(
                    'cell:' +
                    row.id +
                    ':' +
                    day.dayNumber
                  )
                "
              [class.wsb-cell--disabled]="
                  isCellDisabled(row, day.date)
                "
              [class.wsb-cell--rejected]="
                  isCellRejected(row, day.date)
                "
              (dragover)="
                  !isCellDisabled(row, day.date) &&
                  onDragOverTarget(
                    $event,
                    'cell:' +
                    row.id +
                    ':' +
                    day.dayNumber
                  );
                  $event.stopPropagation()
                "
              (dragleave)="onDragLeaveTarget()"
              (drop)="
                  onDropCell($event, row, day);
                  $event.stopPropagation()
                "
              (click)="
                  onTapCell(row, day);
                  $event.stopPropagation()
                "
            >
              <ng-container
                *ngIf="getCellStyle(row, day) as cell"
              >
                <div
                  class="wsb-day-block"
                  [class.wsb-day-block--empty]="!cell.label"
                  [style.background]="cell.bg"
                  [style.color]="cell.color"
                  [attr.draggable]="
                      canSave &&
                      !!row.assignments[day.dayNumber] &&
                      !isCellFromRotation(row, day)
                    "
                  (dragstart)="
                      onPatternDragStart(
                        $event,
                        row.assignments[day.dayNumber]
                          ?.patternId
                      );
                      $event.stopPropagation()
                    "
                  (dragend)="onDragEnd()"
                >
                  <mat-icon
                    class="wsb-day-block-lock"
                    *ngIf="
                        isCellDisabled(row, day.date)
                      "
                    [matTooltip]="getCellLockReason(row, day.date)"
                    matTooltipPosition="above"
                  >
                    lock
                  </mat-icon>

                  <mat-icon
                    class="wsb-day-block-rescheduled"
                    *ngIf="
                        isCellRescheduled(row, day.date)
                      "
                    matTooltip="Reprogramado puntualmente"
                  >
                    swap_horiz
                  </mat-icon>

                  <mat-icon
                    class="wsb-day-block-rotation"
                    *ngIf="isCellFromRotation(row, day)"
                    matTooltip="Viene del patrón catorcenal asignado"
                  >
                    autorenew
                  </mat-icon>

                  <mat-icon
                    class="wsb-day-block-rejected"
                    *ngIf="
                        isCellRejected(row, day.date)
                      "
                    [matTooltip]="getCellRejectedReason(row, day.date)"
                    matTooltipPosition="above"
                  >
                    error
                  </mat-icon>

                  <button
                    type="button"
                    class="wsb-day-block-clear"
                    *ngIf="
                        cell.label &&
                        canSave &&
                        !isCellDisabled(row, day.date) &&
                        !isCellFromRotation(row, day)
                      "
                    draggable="false"
                    title="Quitar turno de este día"
                    (click)="
                        clearCellAssignment(row, day);
                        $event.stopPropagation()
                      "
                    (mousedown)="$event.stopPropagation()"
                  >
                    <mat-icon>close</mat-icon>
                  </button>

                  <ng-container
                    *ngIf="
                        cell.label;
                        else emptyCellTpl
                      "
                  >
                    <div class="wsb-day-block-label">
                      {{ cell.label }}
                    </div>

                    <div class="wsb-day-block-time">
                      {{ cell.timeRange }}
                    </div>
                  </ng-container>

                  <ng-template #emptyCellTpl>
                    <div
                      class="wsb-day-block-empty-hint"
                    >
                      Sin turno
                    </div>
                  </ng-template>
                </div>
              </ng-container>
            </td>

            <td class="wsb-col-total">
                <span
                  class="wsb-total-value"
                  [class.wsb-total-value--exceeds]="
                    getRowTotal(row).exceeds
                  "
                >
                  {{
                    getRowTotal(row).totalHours
                      | number:'1.0-1'
                  }}
                  h
                </span>
            </td>
          </tr>

          <tr *ngIf="filteredPersonnel.length === 0">
            <td
              class="wsb-empty-row"
              [attr.colspan]="9"
            >
              No hay personas que coincidan con el filtro
              actual.
            </td>
          </tr>
          </tbody>
        </table>

        <!-- Dentro de .wsb-table-wrapper (no como hermano de .wsb-main) para que la rueda del
             mouse siga pudiendo hacer scroll de la grilla — un overlay hermano rompe la cadena
             de scroll hacia el contenedor con overflow:auto. -->
        <div
          class="wsb-frozen-overlay"
          *ngIf="!canSave"
          matTooltip="No cuentas con el permiso para programar la jornada"
          matTooltipPosition="above"
        ></div>
      </div>
    </section>
  </div>

  <ng-template #loadingTpl>
    <div class="wsb-loading">
      <mat-icon class="wsb-loading-icon">
        hourglass_empty
      </mat-icon>

      Cargando programación de horarios...
    </div>
  </ng-template>
</div>
